export const DEFAULT_BRAND_ACCENT = "#0055B8";
export const GOLDENTICKET_BRAND_ACCENT = "#C9A063";

export function getBrandAccentColor() {
  if (
    typeof window !== "undefined" &&
    window.isGoldenticket &&
    window.isGoldenticket()
  ) {
    return GOLDENTICKET_BRAND_ACCENT;
  }
  return DEFAULT_BRAND_ACCENT;
}
